<div class="appoitments-history-loader">
  <div class="section">
    <div class="title dark shimmer"></div>

    <div class="content-wrapper">
      <div class="content dark shimmer"></div>
      <div class="content dark shimmer"></div>
      <div class="content dark shimmer"></div>
    </div>
  </div>
</div>
